import dayjs from "dayjs";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

import { URL_SEARCH_PARAMS } from "@/constants/urlSearchParams";

import { TDateFilterState, TDateFilterStore } from "./DateFilter.types";

const dateSearch = new URLSearchParams(location.search).get(URL_SEARCH_PARAMS.DATE);

const initialDateFilterState: TDateFilterState = {
  date: dateSearch
    ? dayjs(dateSearch)
    : dayjs(),
};

export const useDateFilterStore = create<TDateFilterStore>()(
  devtools(set => ({
    ...initialDateFilterState,
    setDate: (date) => {
      set({
        date,
      });
    },
  })),
);
